/**
 * Top bar (main menu) styling
 * 
 * Controls menu item overflow handling and menu alignment/wrapping
 */

const topBar = document.querySelector('.top-bar');
const menuBar = document.querySelector('.top-bar .menu-bar');
const topBarButtons = document.querySelector('.top-bar-buttons');

if (topBar && menuBar) {
  // Get desktop menu breakpoint from CSS
  let desktopMenuBreakpoint = getComputedStyle(document.documentElement)
    .getPropertyValue('--desktop-menu-breakpoint')
    .trim();
  if (!desktopMenuBreakpoint) desktopMenuBreakpoint = '1200px';
  const desktopMenuMediaQuery = window.matchMedia(`(min-width: ${desktopMenuBreakpoint})`);
  // const desktopMenuMediaQuery = window.matchMedia(`(min-width: 1200px)`)

  const menu = menuBar.querySelector('.menu'); 
  const moreLink = menuBar.querySelector('.has-more-dropdown');
  const moreDropdownMenu = document.querySelector('#more-dropdown');
  const buffer = 120; // accounts for width of "More" link + some extra buffer
  
  let menuBarRightMargin = 72; // default margin
  let lastMargin = null; // track previously set margin

  // Handle menu wrapping and item overflow
  function adjustMenu() {
    // Set menu margin on right-aligned menu
    if (topBarButtons && topBar.classList.contains('top-bar-right')) setMenuMargin();

    // Hide menu items that overflow the available space
    // and show them in a 'More' dropdown menu instead
    if (moreLink && moreDropdownMenu) {
      const items = Array.from(menu.querySelectorAll(':scope > li:not(.has-more-dropdown)'));
      // For center-aligned menu, use center section width; otherwise use top bar width
      const centerSection = topBar.querySelector('.top-bar-center-section');
      const containerWidth = centerSection && topBar.classList.contains('top-bar-center') 
        ? centerSection.clientWidth 
        : topBar.clientWidth;     
      // console.log('containerWidth', containerWidth)

      // Reset for measuring
      items.forEach(item => (item.style.display = ''));
      // Save item widths
      const itemWidths = items.map(item => item.getBoundingClientRect().width);

      let spaceTakenUp = 0;
      let overflows = false;

      items.forEach((item, index) => {
        const id = item.dataset.id;
        const duplicate = moreDropdownMenu.querySelector(`li[data-id="${id}"]`);
        const itemWidth = itemWidths[index];

        // console.log('spaceTakenUp',spaceTakenUp + itemWidth + buffer)      
        if (!overflows && spaceTakenUp + itemWidth + buffer <= containerWidth) {
          spaceTakenUp += itemWidth;
          item.style.display = '';
          if (duplicate) duplicate.style.display = 'none';
        } 
        else {
          overflows = true;
          item.style.display = 'none';
          if (duplicate) duplicate.style.display = '';
        }
      });

      // Toggle 'More' link     
      moreLink.style.display = overflows ? '' : 'none';
    }
  }

  // For top-bar-right: set right margin on menu to accommodate width of top-bar-buttons
  function setMenuMargin() {
    const buttonsWidth = topBarButtons.getBoundingClientRect().width;

    // Below breakpoint: reset and exit
    if (!desktopMenuMediaQuery.matches) {
      lastMargin = null
      menuBar.style.marginRight = '72px';
      topBarButtons.style.height = '';
      return;
    }

    menuBarRightMargin = buttonsWidth;

    // Only set the margin if it is different 
    // than the previous margin on window resize
    if (menuBarRightMargin !== lastMargin) {
      menuBar.style.marginRight = `${buttonsWidth}px`;
      lastMargin = menuBarRightMargin;     
      console.log('margin:', menuBarRightMargin);
    }

    adjustButtons();
  }

  // For top-bar-right: adjust button style on menu wrap/unwrap
  function adjustButtons() {
    // Menu wrapped
    if (menuBar.getBoundingClientRect().top > topBar.getBoundingClientRect().top) {
      // Remove search button background
      if (topBarButtons.querySelector('.search-toggle-button')) {
        topBarButtons.querySelector('.search-toggle-button').style.backgroundColor = 'transparent';
      }

      // Set top-bar-buttons height
      const element = topBar.querySelector('.top-bar-logo') || topBar.querySelector('.top-bar-title');
      const height = element 
        ? element.getBoundingClientRect().height 
          + parseFloat(window.getComputedStyle(element).marginTop) 
          + parseFloat(window.getComputedStyle(element).marginBottom)
        : 75;
      topBarButtons.style.height = `${height}px`;
    }
    // Menu inline/unwrapped
    else {
      // Show search button background
      if (topBarButtons.querySelector('.search-toggle-button')) {
        topBarButtons.querySelector('.search-toggle-button').style.backgroundColor = '';
      }

      // Set top-bar-buttons height
      topBarButtons.style.height = '100%';
    }
  }

  // Set banner height to viewport height minus top bar height (unless top-bar-overlay)
  function adjustBannerHeight() {
    const banner = document.querySelector('.banner.viewport-height, .banner.mobile-viewport-height');
    if (banner) {
      const isMobileOnly = banner.classList.contains('mobile-viewport-height') && !banner.classList.contains('viewport-height');
      if (isMobileOnly && desktopMenuMediaQuery.matches) {
        banner.style.height = '';
        return;
      }
      const topBarHeight = document.body.classList.contains('has-top-bar-overlay') && topBar.classList.contains('top-bar-overlay') ? 0 : topBar.getBoundingClientRect().height;
      banner.style.height = `calc(100dvh - ${topBarHeight}px)`;
    }
  }

  // Run once on load
  adjustMenu();
  adjustBannerHeight();

  // Observe resize
  // const resizeObserver = new ResizeObserver(adjustMenu)
  const resizeObserver = new ResizeObserver(entries => {
    // Debounce with requestAnimationFrame: 
    // only run function at the next content repaint; 
    // if multiple resize events happen before the repaint, ignore them
    if (resizeObserver._raf) cancelAnimationFrame(resizeObserver._raf);
    resizeObserver._raf = requestAnimationFrame(() => {
      adjustMenu();
      adjustBannerHeight();
    });
  });

  resizeObserver.observe(topBar);
  resizeObserver.observe(menuBar);
}
